import React from 'react';

import { Group, Text } from '@mantine/core';

import { ReportInfo } from '@/types/patientList';

import styles from './cells.module.scss';
import { ReportName } from './ReportName';

interface PreviousReportCellProps {
  report: ReportInfo | null;
}

export const PreviousReportCell: React.FC<PreviousReportCellProps> = ({ report }) => {
  if (!report) {
    return (
      <Group className={styles.reportCell}>
        <Text className={styles.noReportText}>No previous report</Text>
      </Group>
    );
  }

  return (
    <Group className={styles.reportCell}>
      <div className={styles.reportContent}>
        <ReportName report={report} />
      </div>
    </Group>
  );
};
